<template>
  <div>
    <text-editor
      v-model="content"
      :files-url="filesUrl"
      :upload-url="uploadUrl"
      @input="updatedContent"
    ></text-editor>
  </div>
</template>

<script>
import TextEditor from "./text-editor-partials/TextEditor";
export default {
  props: ["value", "filesUrl", "uploadUrl"],
  data() {
    return {
      content: this.value
    };
  },
  methods: {
    updatedContent() {
      this.$emit("input", this.content);
    }
  },
  components: {
    TextEditor
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/bootstrap.scss";
</style>

